import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-new-date-picker";

export const siteId63: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2428/EMEA_Winter_1400x600.jpg",
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
  car: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
    driveAgeCheckbox: true,
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.MON,
    },
  },
};
